import Paginator, { Page as _Page } from "./Pageinator";
export default Paginator;
export type Page = _Page;